import { useState, useRef } from 'react'
import { Controller } from 'react-hook-form'

export default ({ 
  name, label, 
  control, 
  defaultValue = '',
  disabled = false,
  rules = {},
  validator = {},
  className = '',
  inputProps = {},
  canDelete = false
}) => {
  const [fileName, setFileName] = useState('')
  const fileInputRef = useRef(null)

  const handleFileInputClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  const helperAcceptedFiles = () => {
    const prefixOnlyOneType = "seulement des"

    const acceptTypes = {
      'pdf': "fichiers PDF",
      'image\/': "fichiers image",
      'video\/': "fichiers vidéo",
      'audio\/': "fichiers audio",
      'text\/': "fichiers texte"
    }

    const findMessage = (type) => {
      for (const [pattern, message] of Object.entries(acceptTypes)) {
        if (type.match && type.match(pattern)) {
          return message
        }
      }
    }

    let acceptTypesMsg = []
                      
    if(Array.isArray(inputProps.accept)) {
      acceptTypesMsg = inputProps.accept.map(findMessage)
    } else {
      acceptTypesMsg.push(findMessage(inputProps.accept))
    }
    
    return `Formats acceptés : ${acceptTypesMsg.length == 1 ? `${prefixOnlyOneType} `: ''}${acceptTypesMsg.join(', ')}.`
  }

  const getTextToDisplay = (value) => {
    // Si value est null (fichier supprimé), on affiche "Aucun fichier sélectionné"
    if (value === null) {
      return "Aucun fichier sélectionné"
    }
    
    // Si un fichier est sélectionné, on affiche son nom
    if (fileName) {
      return fileName
    }
    
    // Sinon, on affiche la valeur par défaut ou "Aucun fichier sélectionné"
    return defaultValue.length > 0 ? defaultValue : "Aucun fichier sélectionné"
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field: { onChange, value, ref, ...field } }) => {
        return (
          <div className={`${className} space-y-4`}>
            <div className="flex flex-wrap items-start gap-2">
              <div className='flex flex-col w-full'>
                <label className={`input w-full ${validator.hasError ? 'validator mb-3' : ''}`}
                  {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
                >
                  <span className="label">{label}</span>
                  <div className="w-full overflow-hidden -ml-2 flex items-center">
                    <span
                      className="truncate block text-base-content/70 cursor-pointer hover:text-primary transition-colors flex-grow"
                      onClick={handleFileInputClick}
                    >
                      {getTextToDisplay(value)}
                    </span>
                    {canDelete && value && (
                      <button
                        type="button"
                        className="btn btn-ghost btn-xs text-error"
                        onClick={() => {
                          setFileName('')
                          onChange(null)
                        }}
                        title="Supprimer le fichier"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    )}
                  </div>
                </label>
                {validator.getErrorMessage && (
                  <div className="validator-hint text-error mb-2">
                    {validator.getErrorMessage(name) }
                  </div>
                )}
                <label className="label text-sm">
                  {inputProps.multiple && <span className="mr-1">choisir un ou plusieurs fichiers.</span>}
                  { inputProps.accept && <span className="mr-1 text-sm">
                    {helperAcceptedFiles()}
                  </span>}
                </label>
              </div>
              <label className="btn btn-sm btn-primary text-white">
                Parcourir...
                <input
                  type="file"
                  className="hidden"
                  ref={(e) => {
                    ref(e)
                    fileInputRef.current = e
                  }}
                  {...field}
                  {...inputProps}
                  onChange={(e) => {
                    const file = e.target.files[0]
                    if (file) {
                      setFileName(file.name)
                      onChange(file)
                    } else {
                      setFileName('')
                      onChange(null)
                    }
                  }}
                  disabled={disabled}
                />
              </label>
            </div>
          </div>
        )
      }}
    />
  )
}